import './polyfill'
import "../public/global.css";
import Vue from 'vue'
import apolloProvider from "@/appsync"

const VueResource = () => import('vue-resource')
import VeeValidate from 'vee-validate'

const VueSession = () => import('vue-session')
import { store } from './_controllers';
import { router } from './router/index'
import BootstrapVue from 'bootstrap-vue'

import { $, jQuery } from 'jquery';
import 'jquery-ui-dist/jquery-ui';
window.$ = $;
window.jQuery = jQuery;

// Chart -->https://github.com/highcharts/highcharts-vue
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import mapInit from 'highcharts/modules/map'
mapInit(Highcharts)
Vue.use(HighchartsVue)

import { i18n } from '@/plugins/i18n';
const App = () => import('./App')
const fb = () => import('./fb')
Vue.config.productionTip = false;

var options = {
    persist: true
}
Vue.use(BootstrapVue)
Vue.use(VeeValidate, {
    fieldsBagName: 'vvFields'
});
Vue.use(VueSession, options)
Vue.use(VueResource)

let locationString = window.location.href;

/* eslint-disable no-new */
let app = new Vue({
    el: '#app',
    router,
    store,
    apolloProvider,
    template: locationString.search('fb-display') > 0 ? '<fb />' : '<App/>',
    i18n,
    components: {
        App,
        fb
    }
});


global.vm = app;
